import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface SharedLinkContentStylesClasses {
  formContainer: string;
  formTitle: string;
  form: string;
  formElements: string;
  formInput: string;
  submitButton: string;
  forgotPassword: string;
  helperText: string;
  loginError: string;
  linkError: string;
  largeText: string;
}

const styles = makeStyles<Theme, object, keyof SharedLinkContentStylesClasses>((theme) => {
  return {
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '90vh',
      width: '100%',
      backgroundColor: theme.palette.background.default,
    },
    formTitle: {
      marginTop: '45px',
      marginBottom: '28px',
    },
    form: {
      width: '398px',
      height: '300px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'spaceEvenly',
      alignItems: 'center',
      paddingRight: '34px',
      paddingLeft: '34px',
      paddingBottom: '48px',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
    },
    formElements: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      marginBottom: '8px',
    },
    formInput: {
      marginBottom: '28px',
    },
    submitButton: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    forgotPassword: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
      marginTop: 20,
      padding: 20,
      width: 398,
      justifyContent: 'space-around',
    },
    helperText: {
      position: 'absolute',
      top: '53px',
    },
    loginError: {
      marginTop: '8px',
      marginLeft: '8px',
    },
    linkError: {
      height: '90vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    largeText: {
      fontSize: '88px',
    },
  };
});

export default styles;
